import React, { useState, useEffect } from 'react'
import { useFormik } from 'formik';
import Select from 'react-select'
import DataTables from '../LMS_DATA_TABLE/DataTable';
import { useDispatch, useSelector } from 'react-redux';
import { AiOutlineFileText } from "react-icons/ai";
import { venueListTodo } from '../../LMS_Redux/LMS_Slices/Masters/VenueList';
import { instructorListTodo } from '../../LMS_Redux/LMS_Slices/Assets/InstructorList';
import { courseListTodo } from '../../LMS_Redux/LMS_Slices/Course/CourseList';
// import { groupListTodo } from '../../LMS_Redux/LMS_Slices/Masters/GroupList';
// import { departmentListTodo } from '../../LMS_Redux/LMS_Slices/Assets/DepartmentList';
import { learningTrackListTodo } from '../../LMS_Redux/LMS_Slices/Course/LearningTrackList';
import { userListRes, userListTodo } from '../../LMS_Redux/LMS_Slices/Masters/UserList';
import { trainingDetailsRes, trainingDetailsTodo } from '../../LMS_Redux/LMS_Slices/Course/TrainingDetails';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import PropagateLoader from "react-spinners/PropagateLoader"
import { EditTrainingSchema } from './CourseManagementSchema';
import { updateTrainingRes, updateTrainingTodo } from '../../LMS_Redux/LMS_Slices/Course/UpdateTraining';
import { ToastContainer, toast } from 'react-toastify';
import { trainingTypeTodo } from '../../LMS_Redux/LMS_Slices/Course/TrainingType';
import { Spinner } from 'react-bootstrap';
import { userListByCourseRes, userListByCourseTodo } from '../../LMS_Redux/LMS_Slices/Course/UserListByCourse';

export default function EditTraining() {

    const { state } = useLocation()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const venue = useSelector(state => state.venueList && state.venueList.data && state.venueList.data.data)
    const instructor = useSelector(state => state.instructorList && state.instructorList.data && state.instructorList.data.data)
    const course = useSelector(state => state.courseList && state.courseList.data && state.courseList.data.data)
    const track = useSelector(state => state.learningTrackList && state.learningTrackList.data && state.learningTrackList.data.data)
    // const group = useSelector(state => state.groupList && state.groupList.data && state.groupList.data.data)
    // const department = useSelector(state => state.depratmentList && state.depratmentList.data && state.depratmentList.data.data)
    const training_type = useSelector(state => state.trainingType && state.trainingType.data && state.trainingType.data.data)
    const user_list = useSelector(state => state.userList && state.userList.data && state.userList.data.data)
    const user_list_course = useSelector(state => state.userListByCourse && state.userListByCourse.data && state.userListByCourse.data.data)
    const details = useSelector(state => state.trainingDetails && state.trainingDetails.data && state.trainingDetails.data.data)
    const [loading, setLoading] = useState(false)
    const [userLoading, setUserLoading] = useState(false)
    const [spinner, setSpinner] = useState(false)
    const [user, setUser] = useState([])
    // console.log(details)

    const userRole = JSON.parse(localStorage.getItem('user_data'));
    const role = userRole && userRole.vrole_name

    const venue_list = []
    const course_list = []
    const track_list = []
    // const group_list = []
    // const department_list = []
    const instructor_list = []

    const venue_option = venue && venue.map((value) => venue_list.push({
        "value": value.id,
        "label": value.venue_name
    }))

    const course_option = course && course.map((value) => course_list.push({
        "value": value.id,
        "label": value.course_title
    }))

    const training_type_option = training_type && training_type.map(val => (
        { "value": val.id, "label": val.training_type_title }
    ))

    // const group_option = group && group.map((value) => group_list.push({
    //     "value": value.id,
    //     "label": value.group_name
    // }))

    // const department_option = department && department.map((value) => department_list.push({
    //     "value": value.did,
    //     "label": value.vdepartment_name
    // }))

    const track_option = track && track.map((value) => track_list.push({
        "value": value.id,
        "label": value.learning_title
    }))

    const instructor_option = instructor && instructor.map((value) => instructor_list.push({
        "value": value.vemp_code,
        "label": value.vemp_fname
    }))

    const initialValues = {
        training_id: details && details.id,
        training_title: details && details.training_title,
        training_mode: details && details.training_mode,
        classroom_type: details && details.classroom,
        venue: details && details.vanue_id,
        instructor_name: details && details.instructor_id,
        start_date: details && details.start_date,
        start_time: details && details.start_time,
        end_date: details && details.end_date,
        end_time: details && details.end_time,
        type: details && details.training_type,
        learning_track: details && details.learning_track_id,
        course_wise: details && details.course_data,
        edit_employee: [],
        old_edit_employee: details && details.user_list,
        link: details && details.session_link,
        meeting: details && details.session_meeting_id,
        password: details && details.session_password,
        title: details && details.session_title,
        training_type: details && details.types_of_traininig,
        repetation: details && details.training_interval !== 0 ? 'repeat' : 'no_repeat',
        repeat_count: details && details.training_repeat,
        interval_count: details && details.training_interval,
        // filter_source: 'user',
        // filter_group: '',
        // filter_department: [],
    };

    const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } = useFormik({
        initialValues: initialValues,
        validationSchema: EditTrainingSchema,
        enableReinitialize: true,

        onSubmit: (values, action) => {
            // console.log("new", values)
            setSpinner(true)
            dispatch(updateTrainingTodo(values)).then(() => add_update_res())
            // action.resetForm();
        },
    })

    const add_update_res = () => {

        if (updateTrainingRes && updateTrainingRes.success) {

            setSpinner(false)
            toast.success(updateTrainingRes.message, { position: "bottom-right" })
            setTimeout(() => {
                navigate('/training_list')
            }, 1000);

        } else {
            setSpinner(false)
            toast.error(updateTrainingRes.message, { position: "bottom-right" })
        }
    }

    const [columnDefs, setColumnDefs] = useState([
        {
            headerName: 'NAME',
            field: 'vemp_fname',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            checkboxSelection: true,
            width: 300
        },
        {
            headerName: 'ID',
            field: 'vemp_company_code',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'GROUP',
            field: 'group_ids',
            valueFormatter: function (params) {
                return params?.data?.group_ids?.map(val => `${val.group_name}`).join(',')
            },
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            sortable: true,
            floatingFilter: true,
            wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'DEPARTMENT',
            field: 'vdepartment_name',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'DESIGNATION',
            field: 'vdesignation_name',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'EMAIL',
            field: 'vemail',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'PHONE NO.',
            field: 'vmobile_no',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
    ]);

    // const reset_filter = () => {
    //     setFieldValue("filter_group", '');
    //     setFieldValue("filter_department", []);
    //     setLoading(true)
    //     dispatch(getUserWiseTodo({ "group_data": [], "department_data": [] })).then(() => user_list_res())
    // }

    const reset_type = () => {
        setFieldValue("learning_track", '');
        setFieldValue("course_wise", []);
    }

    // const user_wise = (option, destinaion) => {
    //     if (destinaion == 'group') {
    //         setLoading(true)
    //         dispatch(getUserWiseTodo({ "group_data": [option], "department_data": [] })).then(() => user_list_res())
    //     } else if (destinaion == 'department') {
    //         setLoading(true)
    //         dispatch(getUserWiseTodo({ "group_data": [], "department_data": option })).then(() => user_list_res())
    //     }
    // }

    // const user_list_res = () => {
    //     if (userListRes && userListRes.success) {
    //         setUserLoading(false)
    //         dispatch(trainingDetailsTodo(state.id)).then(() => details_res())
    //     } else {
    //         setUserLoading(false)
    //     }
    // }

    // const details_res = () => {
    //     if (trainingDetailsRes && trainingDetailsRes.success) {
    //         setLoading(false)
    //     } else {
    //         setLoading(false)
    //     }
    // }

    const schedule_user_list = (data, param) => {
        if (param == 'start_date') {
            setFieldValue('edit_employee', [])
            setUserLoading(true)
            dispatch(userListByCourseTodo({ "course": values.course_wise, "track": values.learning_track, "role": "GRD/2", "instructor": values.instructor_name, "start_date": data, "start_time": values.start_time, "end_date": values.end_date, "end_time": values.end_time })).then(() => user_list_res())
        } else if (param == 'start_time') {
            setFieldValue('edit_employee', [])
            setUserLoading(true)
            dispatch(userListByCourseTodo({ "course": values.course_wise, "track": values.learning_track, "role": "GRD/2", "instructor": values.instructor_name, "start_date": values.start_date, "start_time": data, "end_date": values.end_date, "end_time": values.end_time })).then(() => user_list_res())
        } else if (param == 'end_date') {
            setFieldValue('edit_employee', [])
            setUserLoading(true)
            dispatch(userListByCourseTodo({ "course": values.course_wise, "track": values.learning_track, "role": "GRD/2", "instructor": values.instructor_name, "start_date": values.start_date, "start_time": values.start_time, "end_date": data, "end_time": values.end_time })).then(() => user_list_res())
        } else if (param == 'end_time') {
            setFieldValue('edit_employee', [])
            setUserLoading(true)
            dispatch(userListByCourseTodo({ "course": values.course_wise, "track": values.learning_track, "role": "GRD/2", "instructor": values.instructor_name, "start_date": values.start_date, "start_time": values.start_time, "end_date": values.end_date, "end_time": data })).then(() => user_list_res())
        }
    }

    const instructor_user_list = (data) => {
        setFieldValue('edit_employee', [])
        setUserLoading(true)
        dispatch(userListByCourseTodo({ "course": values.course_wise, "track": values.learning_track, "role": "GRD/2", "instructor": data, "start_date": values.start_date, "start_time": values.start_time, "end_date": values.end_date, "end_time": values.end_time })).then(() => user_list_res(data))
    }

    const user_list_res = (id) => {
        if (userListByCourseRes && userListByCourseRes.success) {
            let training_user = details?.user_list?.filter(val => val?.vemp_code !== (id ? id : values?.instructor_name))
            setUser([training_user, userListByCourseRes?.data].flat())
            setUserLoading(false)
        } else {
            let training_user = details?.user_list?.filter(val => val?.vemp_code !== (id ? id : values?.instructor_name))
            setUser([training_user, userListByCourseRes?.data].flat())
            setUserLoading(false)
        }
    }

    const details_res = async () => {
        try {
            if (trainingDetailsRes && trainingDetailsRes.success) {
                await Promise.all([
                    dispatch(venueListTodo({ "status": '', "temp": '' })),
                    dispatch(instructorListTodo()),
                    dispatch(courseListTodo({ "temp": '', "course_availability": 'public', "course_type": 'general' })),
                    dispatch(learningTrackListTodo({ "temp": "" })),
                    dispatch(trainingTypeTodo()),
                    dispatch(userListByCourseTodo({ "course": trainingDetailsRes?.data?.course_data, "track": '', "role": "GRD/2", "instructor": trainingDetailsRes?.data?.instructor_id, "start_date": trainingDetailsRes?.data?.start_date, "start_time": trainingDetailsRes?.data?.start_time, "end_date": trainingDetailsRes?.data?.end_date, "end_time": trainingDetailsRes?.data?.end_time })).then((res) => {
                        let training_user = trainingDetailsRes?.data?.user_list?.filter(val => val?.vemp_code !== trainingDetailsRes?.data?.instructor_id);
                        setUser([training_user, res?.payload?.data].flat())
                    })
                ]);
                setLoading(false)
                setUserLoading(false)
            } else {
                setLoading(false)
                setUserLoading(false)
            }
        } catch (error) {
            setLoading(false)
            setUserLoading(false)
        }
    }

    useEffect(() => {
        setLoading(true)
        setUserLoading(true)
        dispatch(trainingDetailsTodo(state.id)).then(() => details_res())
        // dispatch(venueListTodo({ "status": '', "temp": '' }))
        // dispatch(instructorListTodo())
        // dispatch(courseListTodo({ "temp": '', "course_availability": 'public', "course_type": 'general' }))
        // dispatch(learningTrackListTodo({ "temp": "" }))
        // dispatch(groupListTodo({ "status": '' }))
        // dispatch(departmentListTodo())
        // dispatch(trainingTypeTodo())
        // dispatch(userListTodo({ "role": "GRD/2" })).then(() => user_list_res())
    }, [])

    return (
        <>
            <div className='container-fluid'>
                <div className='scnd-header'>
                    <span className='icon1'>Learning Module Management / </span>
                    <Link to={"/training_list"}><span className='icon2'>Session List / </span></Link>
                    <span className='icon2'>Edit Session</span>
                </div>

                {loading ?
                    <div className='wrapper-admin'>
                        <div className='text-center mb-3'>
                            <PropagateLoader
                                color="#2262C6"
                                size={20}
                            />
                        </div>
                    </div>
                    :
                    <div className='wrapper-admin'>
                        <form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }} method='post'>
                            <div className="row">

                                <div className="col-12 col-md-3">
                                    <div className="mb-3">
                                        <label htmlFor="" className="form-label form_label">Training Mode</label>
                                        <select className="form-select form_input"
                                            name='training_mode' value={values.training_mode || ''}
                                            onChange={(e) => {
                                                handleChange(e);
                                                setFieldValue("classroom_type", '');
                                                setFieldValue("venue", '');
                                                setFieldValue("link", '');
                                                setFieldValue("meeting", '');
                                                setFieldValue("password", '');
                                                setFieldValue("title", '');
                                                setFieldValue("start_date", '');
                                                setFieldValue("start_time", '');
                                                setFieldValue("end_date", '');
                                                setFieldValue("end_time", '');
                                            }}
                                            onBlur={handleBlur}
                                            disabled={true}
                                        >
                                            <option value="">Select</option>
                                            <option value="classroom">Classroom</option>
                                            <option value="virtual">Virtual</option>
                                        </select>
                                        {errors.training_mode && touched.training_mode ? (<span className='text-danger form_label'>{errors.training_mode}</span>) : null}
                                    </div>
                                </div>

                                {values.training_mode == 'classroom' ?
                                    <div className="col-12 col-md-3">
                                        <div className="mb-3">
                                            <label htmlFor="" className="form-label form_label">Classroom Type</label>
                                            <select className="form-select form_input"
                                                name='classroom_type' value={values.classroom_type || ''}
                                                onChange={(e) => {
                                                    handleChange(e);
                                                    setFieldValue("venue", '');
                                                    setFieldValue("link", '');
                                                    setFieldValue("meeting", '');
                                                    setFieldValue("password", '');
                                                    setFieldValue("title", '');
                                                }}
                                                onBlur={handleBlur}
                                                disabled={true}
                                            >
                                                <option value="">Select</option>
                                                <option value="physical">Physical</option>
                                                <option value="live">Live</option>
                                            </select>
                                            {errors.classroom_type && touched.classroom_type ? (<span className='text-danger form_label'>{errors.classroom_type}</span>) : null}
                                        </div>
                                    </div>
                                    : ''
                                }

                                {values.classroom_type == 'physical' ?
                                    <div className="col-12 col-md-3">
                                        <div className="mb-3">
                                            <label htmlFor="" className="form-label form_label">Venue</label>
                                            <Select
                                                // ref={selectInputRef_quiz}
                                                closeMenuOnSelect={true}
                                                options={venue_list}
                                                defaultValue={venue_list && venue_list.find((option) => option.value == values.venue)}
                                                onChange={(e) =>
                                                    // console.log(e)
                                                    setFieldValue('venue', e && e.value || '')
                                                }
                                                onBlur={handleBlur}
                                                name='venue'
                                                // isMulti
                                                placeholder="Select Venue"
                                                classNamePrefix="select"
                                                isDisabled={details && details.is_editable ? '' : true}
                                            />
                                            {errors.venue && touched.venue ? (<span className='text-danger form_label'>{errors.venue}</span>) : null}
                                        </div>
                                    </div>
                                    : ''
                                }

                                <div className="col-12 col-md-3">
                                    <div className="mb-3">
                                        <label htmlFor="" className="form-label form_label">Instructor Name</label>
                                        <Select
                                            // ref={selectInputRef_quiz}
                                            closeMenuOnSelect={true}
                                            options={instructor_list}
                                            defaultValue={instructor_list && instructor_list.find((option) => option.value == values.instructor_name)}
                                            onChange={(e) => {
                                                // console.log(e)
                                                setFieldValue('instructor_name', e && e.value || '');
                                                instructor_user_list(e?.value)
                                            }}
                                            onBlur={handleBlur}
                                            name='instructor_name'
                                            // isMulti
                                            placeholder="Select Instructor"
                                            classNamePrefix="select"
                                            isDisabled={role == "Instructor" ? true : details && details.is_editable ? '' : true}
                                        />
                                        {errors.instructor_name && touched.instructor_name ? (<span className='text-danger form_label'>{errors.instructor_name}</span>) : null}
                                    </div>
                                </div>
                            </div>

                            <div className='row'>

                                <div className="col-12 col-md-3">
                                    <div className="mb-3">
                                        <label htmlFor="" className="form-label form_label">Training Title</label>
                                        <input type="text" className="form_input form-control" placeholder="Training Title"
                                            name='training_title' value={values.training_title || ''} onChange={handleChange} onBlur={handleBlur}
                                            disabled={details && details.is_editable ? '' : true}
                                        />
                                        {errors.training_title && touched.training_title ? (<span className='text-danger form_label'>{errors.training_title}</span>) : null}
                                    </div>
                                </div>

                                <div className="col-12 col-md-3">
                                    <div className="mb-3">
                                        <label htmlFor="" className="form-label form_label">Training Type</label>
                                        <Select
                                            closeMenuOnSelect={true}
                                            options={training_type_option}
                                            defaultValue={training_type_option && training_type_option.find((option) => option.value == values.training_type)}
                                            onChange={(option) =>
                                                setFieldValue('training_type', option && option.value || '')
                                            }
                                            onBlur={handleBlur}
                                            name='training_type'
                                            // isMulti
                                            placeholder="Select Training Type"
                                            classNamePrefix="select"
                                        />
                                        {errors.training_type && touched.training_type ? (<span className='text-danger form_label'>{errors.training_type}</span>) : null}
                                    </div>
                                </div>

                                <div className="col-12 col-md-3">
                                    <div className="mb-3">
                                        <label htmlFor="" className="form-label form_label">Add Learning Module</label>
                                        <select className="form-select form_input"
                                            name='type' value={values.type || ''} onChange={(e) => { handleChange(e); reset_type() }} onBlur={handleBlur}
                                            disabled={true}
                                        >
                                            <option value="">Select</option>
                                            <option value="Learning Path">Learning path</option>
                                            <option value="Course Wise">Learning Module Wise</option>
                                        </select>
                                        {errors.type && touched.type ? (<span className='text-danger form_label'>{errors.type}</span>) : null}
                                    </div>
                                </div>

                                {values.type == 'Learning Path' ?
                                    <div className="col-12 col-md-3">
                                        <div className="mb-3">
                                            <label htmlFor="" className="form-label form_label">Add Learning Track</label>
                                            <Select
                                                closeMenuOnSelect={true}
                                                options={track_list}
                                                defaultValue={track_list && track_list.find((option) => option.value == values.learning_track)}
                                                // value={values.learning_track}
                                                onChange={(option) =>
                                                    setFieldValue('learning_track', option && option.value || '')
                                                }
                                                onBlur={handleBlur}
                                                name='learning_track'
                                                // isMulti
                                                placeholder="Select Learning Track"
                                                classNamePrefix="select"
                                                isDisabled={true}
                                            />
                                            {errors.learning_track && touched.learning_track ? (<span className='text-danger form_label'>{errors.learning_track}</span>) : null}
                                        </div>
                                    </div>
                                    : ''
                                }

                                {values.type == 'Course Wise' ?
                                    <div className="col-12 col-md-3">
                                        <div className="mb-3">
                                            <label htmlFor="" className="form-label form_label">Learning Module List</label>
                                            <Select
                                                closeMenuOnSelect={false}
                                                options={course_list}
                                                defaultValue={details && values.course_wise}
                                                // value={values.course_wise}
                                                onChange={(option) =>
                                                    setFieldValue('course_wise', option)
                                                }
                                                onBlur={handleBlur}
                                                name='course_wise'
                                                isMulti
                                                placeholder="Select Learning Module"
                                                classNamePrefix="select"
                                                isDisabled={true}
                                            />
                                            {errors.course_wise && touched.course_wise ? (<span className='text-danger form_label'>{errors.course_wise}</span>) : null}
                                        </div>
                                    </div>
                                    : ''
                                }


                                <h6 className=''>
                                    Session Interval
                                </h6>

                                <div className="col-12 col-md-4">
                                    <div className="mb-3">
                                        <label htmlFor="" className="form-label form_label">Repetation</label>
                                        <select className="form-select form_input"
                                            name='repetation' value={values.repetation}
                                            onChange={(e) => {
                                                handleChange(e);
                                                setFieldValue("repeat_count", '');
                                                setFieldValue("interval_count", '');
                                            }}
                                            onBlur={handleBlur}
                                            disabled={true}
                                        >
                                            <option value="">Select</option>
                                            <option value="repeat">Repeat</option>
                                            <option value="no_repeat">No Repeat</option>
                                        </select>
                                        {errors.repetation && touched.repetation ? (<span className='text-danger form_label'>{errors.repetation}</span>) : null}
                                    </div>
                                </div>

                                {values.repetation == 'repeat' ?
                                    <div className="col-12 col-md-4">
                                        <div className="mb-3">
                                            <label htmlFor="" className="form-label form_label">Interval (In Days)</label>
                                            <input type="number" className="form_input form-control" placeholder="Interval (In Days)"
                                                name='interval_count' value={values.interval_count || ''} onChange={handleChange} onBlur={handleBlur} disabled={true}
                                            />
                                            {errors.interval_count && touched.interval_count ? (<span className='text-danger form_label'>{errors.interval_count}</span>) : null}
                                        </div>
                                    </div>
                                    : ''
                                }

                                {values.repetation == 'repeat' ?
                                    <div className="col-12 col-md-4">
                                        <div className="mb-3">
                                            <label htmlFor="" className="form-label form_label">Repeat</label>
                                            <input type="number" className="form_input form-control" placeholder="Repeat"
                                                name='repeat_count' value={values.repeat_count || ''} onChange={handleChange} onBlur={handleBlur} disabled={true}
                                            />
                                            {errors.repeat_count && touched.repeat_count ? (<span className='text-danger form_label'>{errors.repeat_count}</span>) : null}
                                        </div>
                                    </div>
                                    : ''
                                }

                                <h6 className=''>
                                    Schedule
                                </h6>

                                {values.training_mode == 'classroom' ?
                                    <div className="col-12 col-md-3">
                                        <div className="mb-3">
                                            <label htmlFor="" className="form-label form_label">Start Date</label>
                                            <input type="date" className="form-control form_input"
                                                name='start_date' value={values.start_date || ''} onChange={(e) => { handleChange(e); schedule_user_list(e?.target?.value, 'start_date') }} onBlur={handleBlur}
                                                // min={new Date(values.start_date).toISOString().split('T')[0]}
                                                min={values.start_date}
                                                disabled={details && details.is_editable ? '' : true}
                                            />
                                            {errors.start_date && touched.start_date ? (<span className='text-danger form_label'>{errors.start_date}</span>) : null}
                                        </div>
                                    </div>
                                    : ''
                                }

                                {values.training_mode == 'classroom' ?
                                    <div className="col-12 col-md-3">
                                        <div className="mb-3">
                                            <label htmlFor="" className="form-label form_label">Start Time</label>
                                            <input type="time" className="form-control form_input"
                                                name='start_time' value={values.start_time || ''} onChange={(e) => { handleChange(e); schedule_user_list(e?.target?.value, 'start_time') }} onBlur={handleBlur}
                                                disabled={details && details.is_editable ? '' : true}
                                            />
                                            {errors.start_time && touched.start_time ? (<span className='text-danger form_label'>{errors.start_time}</span>) : null}
                                        </div>
                                    </div>
                                    : ''
                                }

                                {values.training_mode == 'classroom' ?
                                    <div className="col-12 col-md-3">
                                        <div className="mb-3">
                                            <label htmlFor="" className="form-label form_label">End Date</label>
                                            <input type="date" className="form_input form-control"
                                                name='end_date' value={values.end_date || ''} onChange={(e) => { handleChange(e); schedule_user_list(e?.target?.value, 'end_date') }} onBlur={handleBlur}
                                                min={values.start_date}
                                                disabled={details && details.is_editable ? '' : true}
                                            />
                                            {errors.end_date && touched.end_date ? (<span className='text-danger form_label'>{errors.end_date}</span>) : null}
                                        </div>
                                    </div>
                                    : ''
                                }

                                {values.training_mode == 'classroom' ?
                                    <div className="col-12 col-md-3">
                                        <div className="mb-3">
                                            <label htmlFor="" className="form-label form_label">End Time</label>
                                            <input type="time" className="form_input form-control"
                                                name='end_time' value={values.end_time || ''} onChange={(e) => { handleChange(e); schedule_user_list(e?.target?.value, 'end_time') }} onBlur={handleBlur}
                                                disabled={details && details.is_editable ? '' : true}
                                            />
                                            {errors.end_time && touched.end_time ? (<span className='text-danger form_label'>{errors.end_time}</span>) : null}
                                        </div>
                                    </div>
                                    : ''
                                }

                            </div>

                            {values.classroom_type == 'live' ?
                                <div className='mt-4'>
                                    <div className="row">

                                        <div className='col-12 addcourse_heading'>
                                            <div className='circle'><AiOutlineFileText /></div>
                                            <h6>New Live Session</h6>
                                        </div>

                                        <div className="col-12 col-md-4">
                                            <div className="mb-3">
                                                <label htmlFor="" className="form-label form_label">Insert the link of live session here</label>
                                                <input type="text" className="form_input form-control" placeholder="Insert the link of live session here"
                                                    name='link' value={values.link || ''} onChange={handleChange} onBlur={handleBlur}
                                                    disabled={details && details.is_editable ? '' : true}
                                                />
                                                {errors.link && touched.link ? (<span className='text-danger form_label'>{errors.link}</span>) : null}
                                            </div>
                                        </div>

                                        <div className="col-12 col-md-4">
                                            <div className="mb-3">
                                                <label htmlFor="" className="form-label form_label">Meeting ID</label>
                                                <input type="text" className="form_input form-control" placeholder="Meeting ID"
                                                    name='meeting' value={values.meeting || ''} onChange={handleChange} onBlur={handleBlur}
                                                    disabled={details && details.is_editable ? '' : true}
                                                />
                                                {errors.meeting && touched.meeting ? (<span className='text-danger form_label'>{errors.meeting}</span>) : null}
                                            </div>
                                        </div>

                                        <div className="col-12 col-md-4">
                                            <div className="mb-3">
                                                <label htmlFor="" className="form-label form_label">Password</label>
                                                <input type="password" className="form_input form-control" placeholder="Password"
                                                    name='password' value={values.password || ''} onChange={handleChange} onBlur={handleBlur}
                                                    disabled={details && details.is_editable ? '' : true}
                                                />
                                                {errors.password && touched.password ? (<span className='text-danger form_label'>{errors.password}</span>) : null}
                                            </div>
                                        </div>

                                        <div className="col-12 col-md-4">
                                            <div className="mb-3">
                                                <label htmlFor="" className="form-label form_label">Title</label>
                                                <input type='text' className="form-control form_input" placeholder="Title"
                                                    name='title' value={values.title || ''} onChange={handleChange} onBlur={handleBlur}
                                                    disabled={details && details.is_editable ? '' : true}
                                                />
                                                {errors.title && touched.title ? (<span className='text-danger form_label'>{errors.title}</span>) : null}
                                            </div>
                                        </div>

                                        {/* <div className="col-12 col-md-4">
                                        <div className="mb-3">
                                            <label htmlFor="Date" className="form-label form_label">Date</label>
                                            <input type='date' className="form-control form_input" placeholder="Date" />
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-4">
                                        <div className="mb-3">
                                            <label htmlFor="Date" className="form-label form_label">Duration</label>
                                            <input type='time' className="form-control form_input" placeholder="Duration" />
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-4">
                                        <div className="mb-3">
                                            <label htmlFor="Description" className="form-label form_label">Description</label>
                                            <textarea className="form-control form_input" placeholder="Type Your Description here" />
                                        </div>
                                    </div> */}
                                        {/* <div className="col-12 col-md-5">
                                    <div className="mb-3">
                                        <label htmlFor="Description" className="form-label form_label">Enrollment by Department/Group/User</label>
                                        <select name="" className="form-select form_input">
                                            <option value="">Group</option>
                                            <option value="">Department</option>
                                            <option value="">User</option>
                                        </select>
                                    </div>
                                </div> */}
                                    </div>
                                </div>
                                : ''
                            }

                            <div className='mt-2'>
                                <h6>Enrol Employees to Training</h6>

                                {userLoading ?
                                    <div className='text-center mb-3'>
                                        <PropagateLoader
                                            color="#2262C6"
                                            size={20}
                                        />
                                    </div>
                                    :
                                    <>
                                        <DataTables
                                            rowData={user}
                                            columnDefs={columnDefs}
                                            selection={true}
                                            value={setFieldValue}
                                            field={"edit_employee"}
                                            check={"multiple"}
                                            preSelected={details && details.user_list}
                                            editTrainingCheck={true}
                                        />
                                        {errors.edit_employee && touched.edit_employee ? (<span className='text-danger form_label'>{errors.edit_employee}</span>) : null}
                                    </>
                                }
                            </div>
                            <div className='text-end mt-4'>
                                <button className='btn btn_submit' type='submit' disabled={spinner ? true : false}>Submit
                                    {spinner ?
                                        <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                            className='ms-2'
                                        />
                                        : ''
                                    }
                                </button>
                            </div>
                        </form>
                    </div>
                }
            </div>
            <ToastContainer />
        </>
    )
}
